/*
Push event details to Datalayer, to be passed to Google services (Tag Manager)
*/
function pushEventToDatalayer(event) {
  window.dataLayer.push({
    'event': 'gaEvent',
    'eventCategory': event.eventCategory,
    'eventAction': event.eventAction,
    'eventLabel': event.eventLabel
  });
}

/*
Push object to Datalayer, to be passed to Google services (Tag Manager)
*/
function pushObjectToDatalayer(object) {
  window.dataLayer.push(object);
}

export default { pushEventToDatalayer, pushObjectToDatalayer };
export { pushEventToDatalayer, pushObjectToDatalayer };
